import React from "react";
import { Helmet } from "react-helmet";

export default function Impressum() {
  return (
    <>
      <Helmet>
        <title>Impressum | Kaminfeger Knapp Buchs</title>
        <meta
          name="description"
          content="Impressum von Kaminfeger Knapp: gesetzlich vorgeschriebene Anbieterkennzeichnung mit Firmenangaben, Kontaktinformationen und Verantwortlichkeiten."
        />
      </Helmet>

      <div className="kn-page p-8 max-w-3xl mx-auto">
        <h1 className="kn-h1 mb-6">Impressum</h1>

        <div className="kn-body space-y-4">
          <p>
            <strong className="text-knapp-ink">Marco Knapp</strong>
          </p>
          <p>
            Schützenhausweg 8 <br />
            9470 Buchs <br />
            Schweiz
          </p>

          <p>
            <strong className="text-knapp-ink">Kontakt:</strong>
            <br />
            Telefon: +41 79 814 81 32 <br />
            E-Mail:{" "}
            <a href="mailto:kaminfeger-knapp@gmx.ch" className="kn-link">
              kaminfeger-knapp@gmx.ch
            </a>
          </p>

          <p>
            <strong className="text-knapp-ink">
              Umsatzsteuer-Identifikationsnummer:
            </strong>
            <br />
            CH-MWST: 1234
          </p>

          <h2 className="kn-h3 mt-8">Haftung für Inhalte</h2>
          <p>
            Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für
            die Richtigkeit, Vollständigkeit und Aktualität der Inhalte wird
            jedoch keine Gewähr übernommen.
          </p>

          <h2 className="kn-h3 mt-6">Haftung für Links</h2>
          <p>
            Diese Website enthält Links zu externen Websites Dritter, auf deren
            Inhalte kein Einfluss besteht. Für die Inhalte der verlinkten Seiten
            ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
          </p>

          <h2 className="kn-h3 mt-6">Urheberrecht</h2>
          <p>
            Die durch den Seitenbetreiber erstellten Inhalte und Werke auf
            dieser Website unterliegen dem schweizerischen Urheberrecht. Die
            Vervielfältigung, Bearbeitung oder Verbreitung außerhalb der Grenzen
            des Urheberrechts bedarf der schriftlichen Zustimmung des Autors.
          </p>
        </div>
      </div>
    </>
  );
}
